import React, { FunctionComponent, useCallback } from "react";
import { useTranslation } from "react-i18next";

import { useGetVehicleYears } from "../../../queries/useGetVehicleYears";
import { useSearchForm } from "../../../stores/hooks/useSearchForm";
import { ComboBox } from "../../../ui/ComboBox/ComboBox";
import { ComboBoxOption } from "../../../ui/ComboBox/useComboBox";
import { Input } from "../../../ui/Input/Input";
import { Spinner } from "../../../ui/Spinner";
import { CalendarIcon } from "../../../ui/icons/CalendarIcon";
import { ChevronRightIcon } from "../../../ui/icons/ChevronRightIcon";
import { useIsDealerGroup } from "../../DealerGroup/useIsDealerGroup";
import { usePlacement } from "./usePlacement";

export const YearInput: FunctionComponent = () => {
  const [{ dealerId, vehicleYear }, { setYear }] = useSearchForm();
  const { data, isLoading } = useGetVehicleYears();
  const { t } = useTranslation();
  const handleSelect = useCallback(
    (option: ComboBoxOption<number, null> | null): void => {
      setYear(option?.label || null);
    },
    []
  );
  const isDealerGroup = useIsDealerGroup();
  const isOpen = isDealerGroup && !!dealerId && !vehicleYear;

  return (
    <ComboBox
      defaultValue={vehicleYear ?? ""}
      id="year-combo"
      key={isOpen.toString()}
      onSelectOption={handleSelect}
      open={isOpen}
      options={data || []}
      placement={usePlacement()}
    >
      <Input
        after={isLoading ? <Spinner /> : <ChevronRightIcon />}
        aria-label="vehicleYear"
        before={<CalendarIcon />}
        busy={isLoading}
        disabled={!data}
        name="yearId"
        placeholder={t("searchForm.selectYear")}
        readOnly={!data}
        value={vehicleYear || ""}
      />
    </ComboBox>
  );
};
